export enum LocationInterfaceResponseType {
  SUCCESS = 'SUCCESS',
  INVALID_INPUT = 'INVALID_INPUT',
  UNCLEAR_INPUT = 'UNCLEAR_INPUT',
}

export interface LocationsInference {
  type: LocationInterfaceResponseType
  identifiedLocationTypes?: string[]
}
